import { getCurrencyById } from "@/services/currencies/currenciesApi";
import { type CurrencyId, type Currency } from "@/services/currencies/currenciesTypes";
import type { Price, PriceNumeric } from "@/services/prices/priceTypes";
import { isNumericPrice } from "@/services/prices/priceValidators";

export const formatAmount = (amount: number, currency: Currency): string => {
  const numStr = amount.toLocaleString("en");
  const [integerPart, decimalPart] = numStr.split(".");
  const formattedIntegerPart = integerPart.replaceAll(",", currency.thousandsSeparator);

  let formattedNumber = formattedIntegerPart;
  if (decimalPart !== undefined) {
    formattedNumber += currency.decimalSeparator + decimalPart;
  }

  return formattedNumber;
};

export const formatAmountWithCurrency = (amount: number, currency: Currency): string => {
  const formattedAmount = formatAmount(amount, currency);
  const separator = currency.isSpaceSeparator ? " " : "";

  return currency.isPositionLeft ? `${currency.symbol}${separator}${formattedAmount}` : `${formattedAmount}${separator}${currency.symbol}`;
};

export const convert = async (price: Price, toCurrencyId: CurrencyId): Promise<Price> => {
  if (!isNumericPrice(price)) {
    return price;
  }

  const currencyFrom = await getCurrencyById(price.currencyId);
  const currencyTo = await getCurrencyById(toCurrencyId);

  const decimalPrecision = currencyTo.decimalPrecisionWhenCurrencySwitch;
  const ratio = currencyFrom.ratioThousands[currencyTo.id] / 1000;
  const priceConverted = price.price * ratio;
  const withoutDecimals = Number(priceConverted.toFixed(decimalPrecision));

  return {
    price: withoutDecimals,
    currencyId: currencyTo.id,
  };
};

export const assertSameCurrency = (price1: PriceNumeric, price2: PriceNumeric, msg?: string): void => {
  if (price1.currencyId !== price2.currencyId) {
    throw new Error(msg ?? "Two prices with different currency!");
  }
};
